import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../navbar/Navbar";

// components

const DashboardLayout = () => {
  // const authStatus = useAppSelector(state => state.user.authStatus)

  // if(!authStatus){
  //   return <Navigate to="/login"/>
  // }

  return (
    <>
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-60 lg:flex-col">
        <Sidebar />
      </div>
      <Navbar />
      <main className="lg:pl-60">
        <div className="main-section flex flex-1 items-stretch md:overflow-hidden">
          <main className="flex-1 p-2">
            <Outlet />
          </main>
        </div>
      </main>
    </>
  );
};

export default DashboardLayout;
